<template>
  <el-select
    v-model="selectValue"
    :placeholder="placeHolderText"
    :size="size"
    clearable
    @change="onSelectionChange"
    @clear="onSelectionClear"
    :filterable="filterable"
    :disabled="disabled"
    :loading="isLoading"
    :filter-method="pinyinMatchFilter"
  >
    <el-option
      v-for="item in dataList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
/**
 * 参数
 *  - placeHolderText  select框提示文字，可选，缺省值为"请选择"。
 *  - reqUrl  select框数据url地址。reqUrl 和 dataSource 必须有一项。
 *  - reqParam 查询选项时的参数，可选。
 *  - dataSource select框的所有可选项，如果传入有效值，则不会从 reqUrl 拉取。必须形如 [{value:3, lable:'选项名称'}]
 *  - size  select框尺寸，可选，缺省值为空。
 *  - value  接受外部v-model传入的值，可选，缺省值为空。
 *  - fileType  定义要el-option使用的数据字段，必须。 { listKey, label, value }
 */
import { getRequest } from '@/utils/http-service'
import pinyinMatcher from 'pinyin-match'

export default {
  name: 'jy-selector',

  props: {
    placeHolderText: {
      type: String,
      default: '请选择'
    },
    reqUrl: {
      type: String
    },
    reqParam: {
      type: Object
    },
    dataSource: {
      type: Array
    },
    size: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: String,
      default: ''
    },
    fileType: {
      type: Object
    },
    filterable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selectValue: '',
      dataList: [],
      dataListOrigin: [],
      reqUrlD: this.reqUrl,
      reqParamD: this.reqParam,
      isLoading: false
    }
  },

  methods: {
    reset () {
      console.log(this.$options._componentTag + ' reset()', this.defaultValue)
      this._setSelectedValue(this.defaultValue)
      this.onSelectionChange(this.selectValue)
    },

    setCurrentSelectedValue (val) {
      console.log(this.$options._componentTag + ' setCurrentSelectedValue()', val)
      if (this.dataList.length > 0) {
        this._setSelectedValue(val)
        this.onSelectionChange(this.selectValue)
      }
    },

    setReqUrlAndParam (reqUrl, reqParam) {
      this.reqUrlD = reqUrl
      this.reqParamD = reqParam
      this.selectValue = ''
      this.dataList = []
      this.dataListOrigin = []
      this.getDataList()
    },

    setDataSource (dataSource) {
      // if (!Array.isArray(dataSource) || dataSource.length === 0) {
      //   console.error(this.$options._componentTag + ' setDataSource() dataSource不能为空！')
      //   return
      // }

      for (let i = 0; i < dataSource.length; i++) {
        let keys = Object.keys(dataSource[i])
        let hasValueKey = false
        let hasLabelKey = false
        keys.forEach(key => {
          if (key === 'value') {
            hasValueKey = true
          }
          if (key === 'label') {
            hasLabelKey = true
          }
        })
        if (!hasValueKey || !hasLabelKey) {
          console.error(this.$options._componentTag + ' setDataSource() dataSource必须形如[{value, label}]！')
          return
        }
      }

      this.dataList = Object.assign(dataSource)
      this.dataListOrigin = this.dataList
      if (this.dataList.length === 0) {
        this.selectValue = ''
      }
      // this.selectValue = this.dataList.length === 0 ? '' : this.dataList[0].value
      // this.$emit('selectionChange', this.selectValue)
    },

    onSelectionChange (e) {
      console.log(this.$options._componentTag + ' onSelectionChange()', e)
      this.$emit('selectionChange', this.selectValue)
    },

    onSelectionClear () {
      console.log(this.$options._componentTag + ' onSelectionClear()')
      this.dataList = this.dataListOrigin
    },

    pinyinMatchFilter (val) {
      let that = this

      if (!val) {
        that.dataList = that.dataListOrigin
        return
      }
      that.dataList = that.dataListOrigin.filter(item => {
        return pinyinMatcher.match(item.label, val)
      })
    },

    getDataList () {
      if (Array.isArray(this.dataSource) && this.dataSource.length > 0) {
        this.dataList = this.dataSource
        this.dataListOrigin = this.dataList
        return
      }

      if (!this.reqUrl) {
        console.warn(this.$options._componentTag + ' getDataList() err: No reqUrl!')
        return
      }
      if (!this.fileType) {
        console.warn(this.$options._componentTag + ' getDataList() err: fileType is not object!')
        return
      }
      this.isLoading = true
      getRequest(this.reqUrlD, this.reqParamD)
        .then(res => {
          if (!res || !res.data) {
            this.isLoading = false
            console.error(this.$options._componentTag + ' getDataList() err: 当前没有任何可选择数据！' + this.reqUrl)
            this.dataList = []
            this.dataListOrigin = []
            this.selectValue = ''
            return
          }

          let dataList = this._convertDto2Vo(!this.fileType.listKey ? res.data : res.data[this.fileType.listKey])
          this.isLoading = false

          if (!Array.isArray(dataList)) {
            this.$message({
              showClose: true,
              message: '当前没有任何可选择数据！',
              offset: 300
            })
            console.error(this.$options._componentTag + ' getDataList() err: 当前没有任何可选择数据！' + this.reqUrl)
            this.dataList = []
            this.dataListOrigin = this.dataList
            this.selectValue = ''
            return
          }

          this.dataList = dataList
          this.dataListOrigin = this.dataList
          this._setSelectedValue(this.defaultValue)
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$options._componentTag + ' getDataList() err' + err)
          this.dataList = []
          this.dataListOrigin = this.dataList
          this.selectValue = ''
        })
    },

    _convertDto2Vo (dto) {
      let vo = []
      for (let i = 0; i < dto.length; i++) {
        vo[i] = {}
        vo[i].label = dto[i][this.fileType.label]
        vo[i].value = '' + dto[i][this.fileType.value]
      }
      return vo
    },

    _setSelectedValue (dstValue) {
      if (typeof dstValue !== 'undefined') {
        for (let i = 0; i < this.dataList.length; i++) {
          if (Number(this.dataList[i].value) === Number(dstValue)) {
            this.selectValue = this.dataList[i].value
            return
          }
        }
      }
      this.selectValue = ''
    }
  },

  mounted () {
    this.selectValue = ''
    this.getDataList()
  },

  watch: {
    reqParam (val) {
      this.reqParamD = val
      this.getDataList()
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/jy-selector/index.vue